import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ArrowDownOutlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4.99982 11.9028L11.0069 17.9099V1.74753H13.0067V17.9209L18.9959 11.9318L20.4102 13.3461L12.0123 21.7437L3.58559 13.3171L4.99982 11.9028Z",
    fill: "currentColor"
  }));
}